import { render, staticRenderFns } from "./MediaTitleBlock.vue?vue&type=template&id=b6b1408c"
import script from "./MediaTitleBlock.vue?vue&type=script&lang=js"
export * from "./MediaTitleBlock.vue?vue&type=script&lang=js"
import style0 from "./MediaTitleBlock.vue?vue&type=style&index=0&id=b6b1408c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports